
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 11 13"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.336 2.736l.514-.52v2.986a.65.65 0 101.3 0V2.216l.514.52a.65.65 0 001.065-.212.651.651 0 00-.142-.712L5.962.185A.65.65 0 005.747.05a.65.65 0 00-.494 0 .65.65 0 00-.215.136L3.413 1.812a.654.654 0 00.923.924zm5.065.879a.662.662 0 10-.936.936A4.198 4.198 0 015.5 11.716a4.19 4.19 0 01-3.874-2.59 4.2 4.2 0 01.91-4.575.663.663 0 00-.937-.936A5.506 5.506 0 005.5 13a5.497 5.497 0 005.078-3.39 5.51 5.51 0 00-1.177-5.995z","fill":"#40916C"}})])
          )
        }
      }
    